var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTripDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-TripDetails"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-TripDetails",
    clipPath: "url(#clip-icon-TripDetails)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M963.5,392V632a8,8,0,0,1-8,8h-240a8,8,0,0,1-8-8V542.87a3.992,3.992,0,0,0-3-3.87H639.04a4.011,4.011,0,0,0-3.11,3.08V632a8,8,0,0,1-8,8h-240a8,8,0,0,1-8-8V542.17a4,4,0,0,0-3.09-3.17H320.99a3.862,3.862,0,0,0-.48-.03,2.306,2.306,0,0,1,.37.03h-.85a2.306,2.306,0,0,1,.37-.03,3.862,3.862,0,0,0-.48.03,3.993,3.993,0,0,0-3.42,3.09V632a8,8,0,0,1-8,8H68.5a8,8,0,0,1-8-8V392a8,8,0,0,1,8-8h240a8,8,0,0,1,8,8v87.59a4.035,4.035,0,0,0,3.96,3.46,4.071,4.071,0,0,0,.61-.05h55.6a4,4,0,0,0,3.26-3.2V392a8,8,0,0,1,8-8h240a8,8,0,0,1,8,8v88.03A4,4,0,0,0,638.9,483h65.58a4.014,4.014,0,0,0,3.02-3.02V392a8,8,0,0,1,8-8h240A8,8,0,0,1,963.5,392Z",
    transform: "translate(0.5)",
    fill: "#5797d2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTripDetails);
export default __webpack_public_path__ + "static/media/icon-tripDetails.d106cce0f55441bad80f2526a1a2b329.svg";
export { ForwardRef as ReactComponent };